import { queryOptions, useMutation, useQuery } from '@tanstack/react-query'

import { ApiGateway } from '@/modules/api/api.gateway'
import { TagRepository } from '@/modules/tag/core/tag.repository'
import { CreateTagSchema, UpdateTagSchema } from '@/modules/tag/core/tag.schema'
import { TagService } from '@/modules/tag/core/tag.service'
import { PaginationQueryParams } from '@/shared/schemas/pagination'

const apiGateway = new ApiGateway()
const tagRepository = new TagRepository(apiGateway)
const tagService = new TagService(tagRepository)

export const tagsQueryOptions = queryOptions({
  queryFn: () => tagService.getAll(),
  queryKey: ['tags'],
})

export const tagQueryOptions = (tagId: string, filters: PaginationQueryParams) =>
  queryOptions({
    queryFn: () => tagService.get(tagId, filters),
    queryKey: ['tags', tagId, filters],
  })

export const tagsSearchByNameQueryOptions = (name: string) =>
  queryOptions({
    enabled: !!name,
    queryFn: () => tagService.searchByName(name),
    queryKey: ['tags', 'search', name],
  })

export const useTagsSearchByName = (name: string) => {
  return useQuery(tagsSearchByNameQueryOptions(name))
}

export const useTags = () => {
  return useQuery(tagsQueryOptions)
}

export const useCreateTag = () => {
  return useMutation({
    mutationFn: (data: CreateTagSchema) => tagService.create(data),
  })
}

export const useUpdateTag = () => {
  return useMutation({
    mutationFn: ({ data, tagId }: { data: UpdateTagSchema; tagId: string }) => tagService.update(tagId, data),
  })
}
